export class BrowserStorageService {
  constructor(gaApp) {
    this.gaApp = gaApp
    this._localAvailableCache = null
    this._sessionAvailableCache = null
  }

  get isLocalAvailable() {
    if (this._localAvailableCache !== null) {
      return this._localAvailableCache
    }

    try {
      if (typeof window === 'undefined') {
        this._localAvailableCache = false
        return false
      }
      const testKey = '__test__'
      window.localStorage.setItem(testKey, testKey)
      window.localStorage.removeItem(testKey)
      this._localAvailableCache = true
      return true
    } catch {
      this._localAvailableCache = false
      return false
    }
  }

  get isSessionAvailable() {
    if (this._sessionAvailableCache !== null) {
      return this._sessionAvailableCache
    }

    try {
      if (typeof window === 'undefined') {
        this._sessionAvailableCache = false
        return false
      }
      const testKey = '__test__'
      window.sessionStorage.setItem(testKey, testKey)
      window.sessionStorage.removeItem(testKey)
      this._sessionAvailableCache = true
      return true
    } catch {
      this._sessionAvailableCache = false
      return false
    }
  }

  get local() {
    return {
      get: (key) => {
        if (!this.isLocalAvailable) return undefined

        try {
          const item = window.localStorage.getItem(key)

          if (item === 'undefined') return undefined

          try {
            return JSON.parse(item) || null
          } catch {
            return item ?? null
          }
        } catch {
          return undefined
        }
      },

      set: (key, value) => {
        if (!this.isLocalAvailable) return undefined

        if (!key) {
          throw new Error('Необходимо указать key')
        }

        try {
          window.localStorage.setItem(key, JSON.stringify(value))
        } catch {
          return undefined
        }
      },

      has: (key) => {
        if (!this.isLocalAvailable) return false

        try {
          return Boolean(window.localStorage.getItem(key))
        } catch {
          return false
        }
      },

      remove: (key) => {
        if (!this.isLocalAvailable) return undefined

        try {
          window.localStorage.removeItem(key)
        } catch {
          return undefined
        }
      },

      clear: () => {
        if (!this.isLocalAvailable) return undefined

        try {
          window.localStorage.clear()
        } catch {
          return undefined
        }
      },
    }
  }

  get session() {
    return {
      get: (key) => {
        if (!this.isSessionAvailable) return undefined

        try {
          const item = window.sessionStorage.getItem(key)

          try {
            return JSON.parse(item) || null
          } catch {
            return item ?? null
          }
        } catch {
          return undefined
        }
      },

      set: (key, value) => {
        if (!this.isSessionAvailable) return undefined

        if (!key) {
          throw new Error('Необходимо указать key')
        }

        try {
          window.sessionStorage.setItem(key, JSON.stringify(value))
        } catch {
          return undefined
        }
      },

      has: (key) => {
        if (!this.isSessionAvailable) return false

        try {
          return Boolean(window.sessionStorage.getItem(key))
        } catch {
          return false
        }
      },

      remove: (key) => {
        if (!this.isSessionAvailable) return undefined

        try {
          window.sessionStorage.removeItem(key)
        } catch {
          return undefined
        }
      },

      clear: () => {
        if (!this.isSessionAvailable) return undefined

        try {
          window.sessionStorage.clear()
        } catch {
          return undefined
        }
      },
    }
  }
}
